import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { theme } from "@theme";

const ExclusiveSongText = ({ label }: { label: string }) => {
  return (
    <LBox flexDirection="row" alignItems="center" gap="s1_5">
      <LIcon
        colors={{ color: theme.colors.lightGrey }}
        name="access"
        size={16}
      />
      <LText variant="Body/B1/Medium" color="lightGrey">
        {label}
      </LText>
    </LBox>
  );
};

export default ExclusiveSongText;
